export const API_URL = "https://is-neywabe.pharus-dev.ru/";
export const API_PATH = "ws/restapi/v1/";
export const SITE_KEY = "";
